/** Open an internal app route in a new browser tab with noopener (spec §14). */

export function openPageInNewTab(path: string): void {
  const normalized = path.startsWith('/') ? path : `/${path}`
  const url = `${window.location.origin.replace(/\/+$/, '')}${normalized}`
  window.open(url, '_blank', 'noopener,noreferrer')
}
